import queryString from 'query-string';

export const parseQuery = (search) => {
  return queryString.parse(search) || {};
};
